import React, { useState, useEffect } from "react";
import { TCText } from "../../components/TCText/TCText";
import { Colors } from "../../utils/colors";
import { useLoginStore } from "../../stores/StoreContext";

type props = {};

export const ResendOTPAgain: React.FC<props> = () => {
  const [timeLeft, setTimeLeft] = useState<number | null>(null);
  const [canResend, setCanResend] = useState(false);
  const loginStore = useLoginStore();

  // Initialize timer on first render
  useEffect(() => {
    setTimeLeft(3);
  }, []);

  useEffect(() => {
    if (timeLeft !== null && timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prev) => (prev !== null ? prev - 1 : null));
      }, 1000);
      return () => clearInterval(timer);
    } else if (timeLeft === 0) {
      setCanResend(true);
    }
  }, [timeLeft]);

  const handleResend = () => {
    loginStore.sendOTPCode();
    setTimeLeft(30);
    setCanResend(false);
  };

  return (
    <div style={{ textAlign: "center" }}>
      {!canResend && timeLeft !== null ? (
        <TCText
          style={{ fontSize: 15, color: Colors.grey, fontWeight: 600 }}
          value={`Resend code again in: ${String(
            Math.floor(timeLeft / 60)
          ).padStart(2, "0")}:${String(timeLeft % 60).padStart(2, "0")}s`}
        />
      ) : (
        <div onClick={handleResend} style={{ cursor: "pointer" }}>
          <TCText
            style={{
              fontSize: 15,
              color: Colors.darkBrown,
              fontWeight: 600,
              textDecoration: "underline",
            }}
            value="Resend again?"
          />
        </div>
      )}
    </div>
  );
};
